import { Validators } from "@angular/forms"
import { IGianosDatiOperatore, IGianosDesignazioneBeneficiari, IGianosEsecutoreConto, IGianosOperationInfo, IGianosPaymentMode, IGianosPolicyHolder, IGianosPolicyInsured, IGianosTitolareEffettivo } from "src/app/modules/isv/isv.constants"
import { IFormKey } from "src/app/modules/shared/models/forms"
import { IOperationPayment } from "../../../athora/athora.constants"

export const total_redeem_form_template = {
    iban: '',
    authCode: ''
}

export const total_redeem_form_validators = {
    iban: [Validators.required],
    authCode: [Validators.required]
}

export const total_redeem_form_keys: IFormKey[] = [
    {
        id: 'iban-field',
        label: 'Coordinate bancarie',
        controlName: 'iban',
        css: 'col-6',
        type: 'SELECT'
    },
    {
        id: 'auth-code-field',
        label: 'Codice autorizzativo',
        controlName: 'authCode',
        css: 'col-6'
    }
];

export const isv_total_redeem_form_template = {
    iban: '',
    fiscalRegime: null
}

export const isv_total_redeem_form_validators = {
    iban: [Validators.required]
}

export const isv_total_redeem_form_keys: IFormKey[] = [
    {
        id: 'iban-field',
        label: 'Coordinate bancarie',
        controlName: 'iban',
        css: 'col-5',
        type: 'SELECT'
    },
];

export const isv_redeem_form_radio_PG: IFormKey = {
  id: 'fiscal-regime',
  label: 'Regime Fiscale',
  controlName: 'fiscalRegime',
  css: 'col-4',
  type: 'RADIO',
  options: [
    {
      key: 'lordista',
      value: 'Lordista (esercente attività d\'impresa)',
    },
    {
      key: 'nettista',
      value: 'Nettista (non esercente attività d\'impresa)',
    },
  ],
};

export interface IRiscattoTotaleRequest {
    policyNumber: string;
    payments: IOperationPayment;
    authorizationCode: string;
    ndgTutoreODelegato?: string;
    codiceLineaCompagnia?: string[];
    controvaloreLineaCompagnia?: string[];
    consultancyAmount: string;
    taxRegime?: string;
    liquidationSubjects?: any[];
}

export interface IIsvRiscattoTotaleRequest {
    policyNumber: string;
    contraente: IGianosPolicyHolder;
    assicurato: IGianosPolicyInsured;
    polizzaOperazione: IGianosOperationInfo;
    operatoreContraente: IGianosDatiOperatore;
    esecutoreConto?: IGianosEsecutoreConto;
    designazioneBeneficiario?: IGianosDesignazioneBeneficiari[];
    titolareEffettivi?: IGianosTitolareEffettivo[];
    paymentMode: IGianosPaymentMode;
    ndgTutoreODelegato: string;
    codiceLineaCompagnia?: string[];
    controvaloreLineaCompagnia?: string[];
    consultancyAmount: string;
    taxRegime?: string;
    operationPurpose?: string;
    describeExtraData?: any;
}

export const risto_operation_data_form_validators = {
    agencyCode: [Validators.required],
    policyNumber: [Validators.required],
    productCode: [Validators.required],
    productCategory: [Validators.required],
    reportScope: [Validators.required],
    additionalPaymentType: null,
    redeemType: [Validators.required],
    liquidationType: null,
    withdrawalType: null,
    operationAmount: null,
    paymentType: [Validators.required],
    fundOriginCountry: [Validators.required],
    fundOrigin: [Validators.required],
    fundOriginNote: null,
    designedBeneficiary: [Validators.required],
    contractorNotInsured: [Validators.required],
    operationPurpose: [Validators.required]
}
